"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\theight: 1em;\n\twidth: 1em;\n"], ["\n\theight: 1em;\n\twidth: 1em;\n"]),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: ", ";\n"], ["\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: ", ";\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconWrapper = _styledComponents2.default.div(_templateObject);

var NoIcon = _styledComponents2.default.div(_templateObject2, _ramda2.default.prop("stroke"));

// export default withTheme(props => {
// 	const stroke = props.stroke || R.path(["theme", "colors", "black",])(props) || "#000";

// 	return (
// 		<IconWrapper { ...props }>
// 			{
// 				props.icon
// 				? (
// 					<props.icon
// 						width = "100%"
// 						height = "100%"
// 						stroke = { stroke }
// 						{ ...R.pick(["strokeWidth",])(props) }
// 					/>
// 				)
// 				: <NoIcon stroke = { stroke }/>
// 			}
// 		</IconWrapper>
// 	);
// };

// export default props => null;

var Icon = function Icon(props) {
	var stroke = props.stroke || _ramda2.default.path(["theme", "colors", "black"])(props) || "#000";

	return React.createElement(
		IconWrapper,
		props,
		props.icon ? React.createElement(props.icon, (0, _extends3.default)({
			width: "100%",
			height: "100%",
			stroke: stroke
		}, _ramda2.default.pick(["strokeWidth"])(props))) : React.createElement(NoIcon, { stroke: stroke })
	);
};

exports.default = (0, _styledComponents.withTheme)(Icon);

//# sourceMappingURL=icon.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/icon.js
// module id = 208
// module chunks = 0